import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { GenericService } from '../../generic.service';
import { LandingService } from '../../landing-page/service/landing.service';
import { defaultLanguage } from '../../shared/constants/language.constants';
import { CrowdinService } from '../../shared/service/crowdin.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-contact-us',
    imports: [CommonModule],
    templateUrl: './contact-us.component.html',
    styleUrl: './contact-us.component.scss'
})
export class ContactUsComponent implements OnInit {
  deviceData: any = {};
  deviceData$: any = null;
  feedbacks: any = [];
  selectedFeedbackIndex: number | null = null;
  qrId: any;
  accountNumber: string = '';
  hideHeader: boolean = false;
  translations: { [key: string]: string } = {};
  currentLanguage: string = defaultLanguage;
  languageOptions: Array<{ value: string }> = [];
  isLoadingTranslations = true;
  subs = new Subscription();

  constructor(
    private router: Router,
    private genericService: GenericService,
    private route: ActivatedRoute,
    private landingService: LandingService,
    private crowdinService: CrowdinService,
  ) {
    this.route.data.subscribe((data) => {
      this.hideHeader = data['hideHeader'] || false;
    });
    this.deviceData$ = this.genericService.deviceData.subscribe((data) => {
      if (data) {
        this.deviceData = data;
      }
    });
  }

  ngOnInit() {
    this.languageOptions = this.landingService.getLanguageOptions();

    const stored = localStorage.getItem('deviceData');
    const selectedName = stored
      ? JSON.parse(stored).languageSelected || defaultLanguage
      : defaultLanguage;
    this.currentLanguage = selectedName;

    this.subs.add(
      this.landingService.languageName$.subscribe((langName) => {
        this.currentLanguage = langName;
        this.translations = this.crowdinService.getAllTranslations();
      }),
    );

    this.landingService.loadTranslations(this.currentLanguage);
  }

  async languageChange(event: any) {
    const selectedLang = event.target.value;
    await this.landingService.loadTranslations(selectedLang);
  }

  navigateToLadingPage() {
    this.landingService.navigateToHomePage();
  }

  goBack() {
    history.go(-1);
  }
}
